import storage from './storage';

class AuthService {
  TOKEN_KEY = 'token';

  getCredentials(): Promise<string | null> {
    return storage.getItem(this.TOKEN_KEY);
  }

  setCredentials(token: string): Promise<void> {
    return storage.setItem(this.TOKEN_KEY, token);
  }

  removeCredentials(): Promise<void> {
    return storage.removeItem(this.TOKEN_KEY);
  }

  static shared = new AuthService();
}

export default AuthService;
